import React from "react";

export default {
    'en_CA': 'English (Canada)',
    'en_US': 'English (United States)',
    'en_GB': 'English (Great Britain)',
    'fr_CA': 'French (Canada)',
    'fr_FR': 'French (France)',
	'fr_BE': 'French (Belgium)',
	'fr_MA': 'French (Morocco)',
    'pt_PT': 'Portuguese (Portugal)',
	'el_GR': 'Greek (Greece)',
	'es_ES': 'Spanish (Spain)',
	'es_MX': 'Spanish (Mexico)',
	'es_CO': 'Spanish (Colombia)',
	'nl_BE': 'Dutch (Belgium)',
	'pt_BR': 'Portuguese (Brazil)',
	'sk_SK': 'Slovak (Slovakia)',
	'sr_RS': 'Serbian (Serbia)',
	'tr_TR': 'Turkish (Turkey)',
    'fi_FI': 'Finnish (Finland)',
    'sv_SE': 'Swedish (Sweden)',
    "Belgrade": "Belgrade",
    "195-199": "195-199",
    "COLLAPSE_ALL": "Κατάρρευση Αγορών",
    "England": "England",
    "SETTINGS": "Ρυθμίσεις",
    "Sandringham Flats": "OPAP Flats",
    "Away/Home": "{1}/{0}",
    "TOTAL_GOALS": "Συνολικά γκολ",
    "235-239": "235-239",
    "St Petersburg": "St Petersburg",
    "MARBLE": "μπίλια",
    "HALF_TIME_RESULT": "Αποτέλεσμα 1ου Ημιχρόνου",
    "TO_WIN": "Νικητής",
    "BET_HISTORY_LABEL": "Για περισσότερο ιστορικό επιλέξτε το Ιστορικό Στοιχημάτων",
    "Turnover on 4th Play": "Λάθος στο 4ο Play",
    "Draw With No Goals": "Ισοπαλία χωρίς Γκολ",
    "NO_LAST_RESULTS": "δεν υπάρχουν τελευταία αποτελέσματα",
    "BALANCE": "Balance",
    "1": "1",
    "2": "2",
    "AT": "@",
    "at": "@",
    "Over 144.5": "Over 144.5",
    "-10001": "Μη έγκυρο αίτημα (Κωδικός σφάλματος: -10001)",
    "-10000": "Μη έγκυρο αίτημα (Κωδικός σφάλματος: -10000)",
    "SECOND_ND": "2",
    "PassTD on 1st Play": "TD με πάσα στο 1ο Play",
    "EIGHT_GAMES": "8 παιχνίδια",
    "FRACTIONAL": "Κλασματικές",
    "OPEN_BETS_ON_BET_SLIP_LIMIT_REACHED": "Έχετε φτάσει το μέγιστο αριθμό στοιχημάτων στο πεδίο του δελτίου. Παρακαλούμε αφαιρέστε ή τοποθετήστε στοιχήματα πριν να προσθέσετε νέα.",
    "PREVIOUS": "πρότερος",
    "OVER_25": "Over 2.5",
    "NO_FUTURE_EVENTS": "Δεν υπάρχουν μελλοντικοί αγώνες",
    "Jennison Stadium": "PS Stadium",
    "180-184": "180-184",
    "RACE_START_TIME": "Ωρα Έναρξης",
    "LAST_TEAM_TO_SCORE": "Τελευταία Ομάδα που θα σκοράρει",
    "Fener": "Fener",
    "INFO_NOTIFICATION": "INFORΠληροφορίαMATION",
    "26-30": "26-30",
    "Cycling": "Ποδηλασία",
    "BROWSER_NOT_SUPPORTED_DETAILS": "Το πρόγραμμα περιήγησης που χρησιμοποιείτε αυτήν τη στιγμή δεν υποστηρίζεται. Χρησιμοποιήστε ένα από τα εξής προγράμματα περιήγησης: Chrome, Firefox ή Safari.",
    "Home to Win and both teams to score": "{0} να κερδίσει \u0026 να σκοράρουν και οι 2 ομάδες",
    "Turnover on 2nd Play": "Λάθος στο 2ο Play",
    "Lyon": "Lyon",
    "EACH_WAY_ODDS_PLACE": "E/W {0} 1-2",
    "PLACE": "Πλασέ",
    "BET_SUMMARY": "Σύνοψη Στοιχημάτων",
    "BET_TYPE_STAKE": "Στοίχημα",
    "BET": "Δελτίο",
    "POT_RETURNS": "Για επιστροφή:",
    "NO_GOALS": "Χωρίς Γκολ",
    "BET_POTENTIAL_RETURNS_OUT_OF_LIMITS_MESSAGE": "Ένα ή περισσότερα ποσά πιθανής επιστροφής ξεπερνούν το μέγιστο ποσό επιστροφής {0}. Παρακαλούμε διορθώστε το πριν την τοποθέτηση των στοιχημάτων σας.",
    "REALITY_CHECK_WARNING_MESSAGE_LINE_1": "The bet(s) you are placing are over {0}.",
    "MIN_STAKE_REALITY_CHECK_WARNING_MESSAGE_LINE_1": 'The bet(s) you are placing are under {0}',
    "REALITY_CHECK_WARNING_MESSAGE_LINE_2": "Is this OK",
    "REALITY_CHECK_TOTAL_STAKE_SINGLE_EVENT_WARNING": "The maximum amount of {0} has been staked. Please select a different event",
    "Orlando": "Orlando",
    "Motorcycles": "Μηχανές",
    "v": "V",
    "Home To Score": "{0} Να σκοράρει",
    "CANCEL": "Ακύρωσε",
    "WON": "Κερδισμένο",
    "x": "x",
    "SIMPLE": "Απλό",
    "DA": "Ισοπαλία/{1}",
    "SUCCESS_NOTIFICATION": "Επιτυχία",
    "-20000": "Δεν είναι δυνατή η σύνδεση (Κωδικός σφάλματος: -20000)",
    "-20002": "Πάρα πολλά αιτήματα (Κωδικός σφάλματος: -20002)",
    "SORT_BY": "Ταξινομώ",
    "-20001": "Δεν είναι δυνατή η σύνδεση (Κωδικός σφάλματος: -20001)",
    "-20004": "Μη έγκυρο αίτημα (Κωδικός σφάλματος: -20004)",
    "Both Score Yes": "Ναι",
    "-20003": "Πάρα πολλά αιτήματα (Κωδικός σφάλματος: -20003)",
    "Oakland": "Oakland",
    "CLOSE_SLIP": "Κλείνω",
    "UNDER_OVER_15": "Over/Under 1.5",
    "NO_CONNECTION_TITLE_TEXT": "Η σύνδεση με τον διακομιστή χάθηκε, βεβαιωθείτε ότι έχετε σταθερή σύνδεση δικτύου και ανανεώστε τη σελίδα. Εάν το πρόβλημα παραμένει, επικοινωνήστε με την υποστήριξη.",
    "PLACE_BETS": "Στοιχημάτισε",
    "N_A": "Δ/Δ",
    "Over 209.5": "Over 209.5",
    "MONEYLINE": "Νικητής",
    "140-144": "140-144",
    "210-214": "210-214",
    "Brazil": "Brazil",
    "PassTD on or after 5th Play": "PassTD on or after 5th Play",
    "-1000": "παιχνίδι έχει τεθεί σε αναστολή. Επικοινωνήστε με την υποστήριξη πελατών.",
    "Barcelona": "Barcelona",
    "+10.5": "+10.5",
    "+5.5": "+5.5",
    "WIN_DRAW_WIN": "Τελικό αποτέλεσμα",
    "Away To Score": "{1} Να σκοράρει",
    "THE MANOR GROUND": "OPAP ARENA",
    "UNDER_OVER_05": "Under/Over 0.5",
    "PREVIOUS_RESULTS": "Προηγούμενα αποτελέσματα",
    "Under 164.5": "Under 164.5",
    "Italy": "Italy",
    "MB_RACE_WIN": "Να Νικήσει",
    "FIRST_TEAM_TO_SCORE": "Πρώτη Ομάδα που θα σκοράρει",
    "Away/Draw": "{1}/Ισοπαλία",
    "36-40": "36-40",
    "UNDO": "undo",
    "MB_RACE_EXACTA": "φορκάστ",
    "LIVE": "LIVE",
    "NO_CONNECTION_TO_VIRGO": "σύνδεση χάθηκε",
    "Over": "Over {0}",
    "1-0,2-0,2-1": "1-0,2-0,2-1",
    "TRICAST": "τρικάστ",
    "MB_RACE_TRIFECTA_BOX": "combo τρικάστ",
    "4-0": "4-0",
    "PassTD on 3rd Play": "TD με πάσα στο 3ο Play",
    "155-159": "155-159",
    "NO_CONNECTION_TO_VIRGO_TEXT": "Ανανεώστε τη σελίδα και συνδεθείτε.",
    "ASIAN_HANDICAP": "Ασιατικό χάντικαπ",
    "Home": "{0}",
    "New York": "New York",
    "Home and 4-0": "{0} και 4-0",
    "2FurlongHorses": "PS Sprints",
    "Home/Away": "{0}/{1}",
    "RACE_START": "Έναρξη Κούρσας",
    "PAYS": "πληρώνει",
    "San Francisco": "San Francisco",
    "Over 219.5": "Over 219.5",
    "POTENTIAL_RETURNS": "Για επιστροφή",
    "HA": "{0}/{1}",
    "NEXT_RACE": "Επόμενη Κούρσα",
    "NO_BETS_RESUME": "Δεν υπάρχουν στοιχήματα για το τρέχον γεγονός",
    "HD": "{0}/Ισοπαλία",
    "Under 214.5": "Under 214.5",
    "HOME": "{0}",
    "ACTIVE_BETS": "Ενεργά Στοιχήματα",
    "ODDS": "Απόδοση",
    "LOOK_FOR_THE_NEXT": "Αναζητήστε τον επόμενο αγώνα",
    "Over 159.5": "Over 159.5",
    "Portugal": "Portugal",
    "Under 154.5": "Under 154.5",
    "3-0": "3-0",
    "3-1": "3-1",
    "HOME_TEAM_TO_SCORE": "{0} Να σκοράρει",
    "Home and 3-0": "{0} και 3-0",
    "165-169": "165-169",
    "LANGUAGE": "Γλώσσα",
    "Home and 3-1": "{0} και 3-1",
    "41-45": "41-45",
    "IN": "σε",
    "OPEN_BETS": "Ανοιχτά",
    "AWAY_TEAM_TO_SCORE": "{1} Να σκοράρει",
    "185-189": "185-189",
    "Away Not To Score": "{1} Να μη σκοράρει",
    "Madrid": "Madrid",
    "Maple Downs": "",
    "MATCH_BETTING_BOTH_TEAMS_SCORE": "Αποτέλεσμα \u0026 Να σκοράρουν και οι 2 ομάδες",
    "NO_LUCK": "ΔΕΝ ΚΕΡΔΙΣΕ",
    "Germany": "Germany",
    "REMOVE_ALL": "Καθαρισμός",
    "UNDER_OVER_35": "Over/Under 3.5",
    "PLAYER_LOGGED_OTHER_PLACE_TITLE_TEXT": "Η σύνδεση έκλεισε, ο χρήστης συνδέθηκε δύο φορές.",
    "BET_CONFIRMED_TEXT":'none',
    "TAX_NOTIFICATION_TEXT": 'none',
    "Portland": "Portland",
    "Draw": "Ισοπαλία",
    "205-209": "205-209",
    "TOTAL_POINTS_OVER_UNDER": "Συνολικοί Πόντοι O/U",
    "Moscow": "Moscow",
    "Costa Rica": "Κόστα Ρίκα",
    "2-0": "2-0",
    "2-1": "2-1",
    "2-2": "2-2",
    "FIRST_LAST_TO_SCORE": "Πρώτη/Τελευταία που θα σκοράρει",
    "Denver": "Denver",
    "COMBINATION_FORECAST": "combo φορκάστ",
    "UNDER_OVER_25": "Over/Under 2.5",
    "Home and 2-1": "{0} και 2-1",
    "Home and 2-2": "{0} και 2-2",
    "NO_CONNECTION_TITLE": "Η σύνδεση χάθηκε",
    "San Antonio": "San Antonio",
    "DRAW": "Ισοπαλία",
    "Greyhounds": "Κυνοδρομίες",
    "SLIP": "Δελτίο",
    "Home and 2-0": "{0} και 2-0",
    "RETURNS": "Επιστρέφει",
    "REVERSE_TRICAST": "Combo Τρικάστ",
    "Over 149.5": "Over 149.5",
    "FIRST": "Πρώτη",
    "Under 144.5": "Under 144.5",
    "Spain": "Spain",
    "Horses Furlong": "Ιπποδρομίες 1/8 του μιλίου",
    "FILTER_WINS": "Κερδών",
    "FINISH_YOUR_BETS": "Ολοκληρώστε τα στοιχήματά σας",
    "DEFENSE_PREVIOUS_RESULTS": "Προηγούμενα αποτελέσματα άμυνας",
    "Home Win By Exactly 1 Goal": "{0} νίκη με ακριβώς 1 Γκολ",
    "RunTD on 2nd Play": "TD με run στο 2ο Play",
    "BET_HISTORY": "Ιστορικό",
    "-967": "Αποτυχία ελέγχου ταυτότητας.",
    "MAX_WINNINGS_REACHED_TEXT": "Το τρέχον στοίχημα υπερβαίνει το μέγιστο επιτρεπόμενο όριο κερδών {0}. Το μέγιστο επιτρεπόμενο ποντάρισμα για αυτό το στοίχημα είναι {1}.",
    "-966": "Υπέρβαση του ορίου μέγιστου κέρδους.",
    "-969": "Σφάλμα Επικοινωνίας.",
    "-5.5": "-5.5",
    "-968": "Σφάλμα Συναλλαγής.",
    "MB_RACE_PLACE": "Να πλασαριστεί",
    "-965": "Invalid parameters passed.",
    "ATTACKS": "(Επιθέσεις) στις",
    "REVERSE_TRICAST_MARBLE": "Πρώτα 3 σε οποιδήποτε σειρα",
    "Utd": "United",
    "Away Win By 3 or more goals": "{1} Νίκη με 3 ή περισσότερα Γκολ",
    "DETAILS": "Πληροφορίες",
    "120-124": "120-124",
    "DECIMAL": "Δεκαδικές",
    "BOTH_TEAMS_SCORE": "Goal/no Goal",
    "-970": "Η συναλλαγή απορρίφθηκε.",
    "-972": "Σφάλμα υπεύθυνου παιχνιδιού.",
    "ADD_TO_BET_SLIP": "Προσθήκη",
    "-971": "Η λειτουργία του Πορτοφολιού απέτυχε.",
    "1-0": "1-0",
    "220-224": "220-224",
    "1-1": "1-1",
    "1-2": "1-2",
    "RETURNED": "Κέρδος:",
    "1-3": "1-3",
    "Real": "Real",
    "-978": "Δεν υπάρχουν επαρκή χρήματα για την εκτέλεση αυτής της συναλλαγής.",
    "Khimki": "Khimki",
    "-977": "Ο έλεγχος απέτυχε.",
    "COVERED": "Καλύφθηκε",
    "MAIN": "Κύρια",
    "-979": "Παρουσιάστηκε σφάλμα κατά την επεξεργασία του αιτήματος (Κωδικός σφάλματος: -979)",
    "UNDER_OVER": "Over/Under",
    "-974": "Υπέρβαση ορίου απώλειών.",
    "-973": "Δεν έχει οριστεί όριο.",
    "-976": "Η λειτουργία του πορτοφολιού αποκλείστηκε προσωρινά.",
    "MB_RACE_SHOW": "Δείξε",
    "Pittsburgh": "Pittsburgh",
    "-975": "Υπέρβαση ορίου στοιχήματος.",
    "Home and 1-2": "{0} και 1-2",
    "BET_STAKE_OUT_OF_LIMITS_MESSAGE": "Ένα ή περισσότερα ποσά στοιχηματισμού δεν είναι έγκυρα. Ελάχιστο στοίχημα {0}, Μέγιστο στοίχημα {1}, παρακαλούμε διορθώστε το πριν την τοποθέτηση των στοιχημάτων σας.",
    "LIST_BET_STAKE_OUT_OF_LIMITS_MESSAGE": 'Stake limits on {0} are Min {1} & Max {2}',
    "Away Exactly 4": "{1} Ακριβώς 4",
    "Home and 1-3": "{0} και 1-3",
    "NO_WIN": "Οχι Νίκη",
    "Away Exactly 3": "{1} Ακριβώς 3",
    "Away Exactly 2": "{1} Ακριβώς 2",
    "Away Exactly 1": "{1} Ακριβώς 1",
    "MB_RACE_ON": "on",
    "Berlin": "Berlin",
    "Home and 1-0": "{0} \u0026 1-0",
    "Home and 1-1": "{0} και 1-1",
    "BOX": "BOX",
    "City": "City",
    "Draw/Away": "Ισοπαλία/{1}",
    "-980": "Παρουσιάστηκε σφάλμα κατά την επεξεργασία του αιτήματος (Κωδικός σφάλματος: -980)",
    "Away Not to Score": "{1} Να μη σκοράρει",
    "RunTD on 4th Play": "TD με run στο 4ο Play",
    "0-3,1-3,0-4": "0-3,1-3,0-4",
    "ND": "ος",
    "THIS_TIME": "ΑΥΤΗ ΤΗ ΦΟΡΑ",
    "Speedway": "Speedway",
    "REVERSE_FORECAST": "Combo Φορκάστ",
    "135-139": "135-139",
    "SPREAD_TOTAL_POINTS": "Χάντικαπ \u0026 Συνολικοί πόντοι O/U",
    "Under 3.5": "Under 3.5",
    "ANY": "κάθε",
    "Horses Flats": "επίπεδες κούρσες",
    "-994": "Χάθηκε η σύνδεση με τον διακομιστή, το στοίχημα σας δεν τοποθετήθηκε.",
    "0-0": "0-0",
    "0-1": "0-1",
    "0-2": "0-2",
    "0-3": "0-3",
    "and": "\u0026",
    "0-4": "0-4",
    "CLEAR_SELECTIONS": "Καθαρίζω",
    "TOTAL_POINTS_UNDER_OVER": "Συνολικοί Πόντοι U/O",
    "-999": "Η συνεδρία έληξε.",
    "France": "France",
    "OK": "OK",
    "-996": "Παρουσιάστηκε σφάλμα κατά την επεξεργασία του αιτήματος (Κωδικός σφάλματος: -996)",
    "-995": "Παρουσιάστηκε σφάλμα κατά την επεξεργασία του αιτήματος (Κωδικός σφάλματος: -995)",
    "-998": "Ο παίκτης αποβλήθηκε",
    "-997": "Η εντολή δεν επιτρέπεται",
    "ON": "on",
    "UNDER_OVER_25_INITIALS": "O/U 2.5",
    "UNDER_OVER_35_INITIALS": "O/U 3.5",
    "Republic of Ireland": "Δημοκρατία της Ιρλανδίας",
    "Istanbul Blues": "Istanbul Blues",
    "Home Win By 3 or more goals": "{0} νίκη με 3 ή περισσότερα Γκολ",
    "REMOVE_CLOSED_EVENTS": "Αφαιρέστε κλειστά",
    "170-174": "170-174",
    "MB_RACE_EXACTA_BOX": "Combo Φορκάστ",
    "SECOND_PLAY": "2ο Play",
    "Mexico": "Mexico",
    "Los Angeles": "Los Angeles",
    "TOTAL_STAKE": "Συνολικό ποντάρισμα",
    "First Down": "1st Down",
    "Paris": "Paris",
    "CLEAR": "εκκαθάριση",
    "Houston": "Houston",
    "Turin": "Turin",
    "ONLY_SHOW_WINS": "Εμφάνιση μόνο νικητήριων",
    "CLEAR_ALL": "Διαγραφή όλων",
    "Draw With Goals": "Ισοπαλία με Γκολ",
    "TRIFECTA": "Τρικάστ",
    "Under 2.5": "Under 2.5",
    "-15.5": "-15.5",
    "FINISHING_ORDER": "Σειρά τερματισμού",
    "TEAM_SCORECAST": "Scorecast",
    "VOIDED": "ΑΚΥΡΩΘΗΚΕ",
    "DOWNLOAD_CHROME": "Λήψη Chrome",
    "Away/Away": "{1}/{1}",
    "HALF_TIME_FULL_TIME": "Ημίχρονο/Τελικό",
    "Inspired Arena": "PS Arena",
    "MAX_WINNINGS_REACHED": "Το κέρδος υπερβαίνει το μέγιστο επιτρεπόμενο",
    "BETS": "Στοιχήματα",
    "ALERT_NOTIFICATION": "Προσοχή",
    "LAST_THREE_GAMES": "Τελευταίοι 3 αγώνες",
    "Home Exactly 2": "{0} Ακριβώς 2",
    "Home Exactly 1": "{0} ακριβώς 1",
    "Argentina": "Argentina",
    "Home Exactly 4": "{0} Ακριβώς 4",
    "Home Exactly 3": "{0} Ακριβώς 3",
    "WARNING_NOTIFICATION": "Προσοχή",
    "WARNING_NOTIFICATION_REALITY_CHECK": "Προσοχή",
    "PassTD on 4th Play": "TD με πάσα στο 4ο Play",
    "TOTAL_POTENTIAL_RETURNS": "Για επιστροφή",
    "Circuit": "PS Circuit",
    "SET_VIDEO_ON_FUL_SCREEN": "Ορισμός βίντεο σε πλήρη οθόνη?",
    "TRIFECTA_BOX": "Combo Τρικάστ",
    "FIFTH_PLAY": "5 Play ή περισσότερα",
    "Barcelona City": "Barcelona City",
    "RD": "ος",
    "Milan": "Milan",
    "Over 214.5": "Over 214.5",
    "RunTD on 1st Play": "TD με run στο 1ο Play",
    "TO_WIN_MARBLE": "Νικητής",
    "DOUBLE_CHANCE": "Διπλή ευκαιρία",
    "BOTH_TEAMS_SCORE_INITIALS": "Γκολ",
    "175-179": "175-179",
    "DATE_LOCATION": "Γεγονός",
    "Over 249": "Over 249",
    "Princess Parkway": "Markopoulo Parkway",
    "MONEY_LINE_TOTAL_POINTS": "Νικητής \u0026 Συνολικοί Πόντοι O/U",
    "SIMPLIFIED_DESKTOP": "Αυτή είναι η κύρια κατηγορία για απλοποιημένο περιβάλλον εργασίας χρήστη για επιτραπέζιους υπολογιστές",
    "LAYOUT": "Διάταξη",
    "Under 1.5": "Under 1.5",
    "Under 159.5": "Under 159.5",
    "RunTD on or after 5th Play": "TD με run στο/ή και μετά το 5ο Play",
    "EXOTIC": "εξωτικό",
    "EIGHT_RESULTS": "8 αγώνες",
    "FIELD_GOAL": "Field Γκολ",
    "Sweden": "Sweden",
    "Switzerland": "Switzerland",
    "Poland": "Poland",
    "Draw/Draw": "Ισοπαλία/Ισοπαλία",
    "OFFENSE_PREVIOUS_RESULTS": "Προηγούμενα αποτελέσματα επίθεσης",
    "Under": "Under {0}",
    "TRICAST_MARBLE": "Πρώτα 3",
    "Dallas": "Dallas",
    "-32602": "Ένα ή περισσότερα στοιχήματα δεν τοποθετήθηκαν εγκαίρως.",
    "Away to Win to nil": "{1} Να κερδίσει με μηδέν παθητικό",
    "SHOW_VIDEO": "Δείτε το Βίντεο",
    "GAME_DISABLED_MESSAGE": " ",
    "DID_NOT_COVER": "Δεν καλύφθηκε",
    "PassTD on 2nd Play": "TD με πάσα στο 2ο Play",
    "ST": "ος",
    "REFUNDED": "Επιστροφές χρημάτων",
    "OPEN_BETS_WARNING": "Μερικά ή όλα τα ανοιχτά στοιχήματα δεν ήταν δυνατό να προστεθούν στο δελτίο επειδή ανήκουν σε προηγούμενα γεγονότα.",
    "Czech Republic": "Czechia",
    "CORRECT_SCORE_GROUP": "Ακριβές Σκορ",
    "NO_MORE_BETS": "Τέλος Στοιχηματισμού",
    "METRO STADIUM": "PS STADIUM",
    "TO": "στο",
    "160-164": "160-164",
    "Philadelphia": "Philadelphia",
    "240-244": "240-244",
    "Other": "Άλλο",
    "HISTORY": "Ιστορικό",
    "200-204": "200-204",
    "Kaunas": "Kaunas",
    "Home to Win to nil": "{0} να κερδίσει με μηδέν παθητικό",
    "Away to Win and both teams to score": "{1} Να κερδίσει και οι δύο ομάδες να σκοράρουν",
    "Home/Draw": "{0}/Ισοπαλία",
    "Iceland": "Ισλανδία",
    "Horses Sprints": "Ιπποδρoμίες Σπριντ",
    "EVENT_HAS_STARTED": "Το γεγονός ξεκίνησε - Παρακαλώ αφαιρέστε τις μη διαθέσιμες επιλογές για να συνεχίσετε",
    "FIRST_PLAY": "1ο Play",
    "Showell Park": "Markopoulo Park",
    "Under 0.5": "Under 0.5",
    "WINS_THE_GAME": "Κερδίζει τον αγώνα",
    "CURRENT_RACE": "Τρέχουσα Κούρσα",
    "THIRD_PLAY": "3ο Play",
    "BET_SLIP": "Δελτίο",
    "DOWNLOAD_FIREFOX": "Λήψη Firefox",
    "Colombia": "Colombia",
    "WIN_INITIAL": "Ν",
    "MB_RACE_TRIFECTA": "Τρικάστ",
    "REVERSE_FORECAST_MARBLE": "Πρώτα 2 σε οποιδήποτε σειρα",
    "Liverpool": "Liverpool",
    "NUMBER": "Αριθμό",
    "TOTAL_BETS": "ΠΟΝΤΑΡΙΣΜΑ:",
    "Vitoria": "Vitoria",
    "Under 149.5": "Under 149.5",
    "Speedway Park": "OPAP Raceway",
    "LAST": "Τελευταία",
    "SELECTION": "Επιλογή",
    "DEFENDS": "(Άμυνες) στις",
    "VS": "vs",
    "PLACED_BETS": "Τοποθετημένα",
    "Horses Trotting": "Horses Trotting",
    "SCORE": "σκορ",
    "EVENT_LIVE": "Αγώνας σε εξέλιξη",
    "190-194": "190-194",
    "UNDER_25": "Under 2.5",
    "OVER_35": "Over 3.5",
    "UNDER_35": "Under 3.5",
    "Russia": "Russia",
    "Netherlands": "Netherlands",
    "31-35": "31-35",
    "TOTAL_POINTS_GROUP": "Συνολικοί Πόντοι (Γκρουπ)",
    "SHOW": "Εμφάνιση",
    "INTERNAL_ERROR": "Εσωτερικό Σφάλμα",
    "DogFlat": "Markopoulo Green",
    "HOME_TEAM_GOALS": "Γκολ ομάδας {0}",
    "Miami": "Miami",
    "AWAY": "{1}",
    "Home/Home": "{0}/{0}",
    "150-154": "150-154",
    "LOSE_INITIAL": "Η",
    "LAST_RESULTS": "Τελευταία Αποτελέσματα",
    "Home Win By Exactly 2 Goals": "{0} νίκη με ακριβώς 2 Γκολ",
    "215-219": "215-219",
    "SIMPLIFIED_MOBILE": "Αυτή είναι η κύρια κατηγορία για απλοποιημένο περιβάλλον εργασίας χρήστη για κινητό",
    "DRAW_INITIAL": "D",
    "Away and 3-1": "{1} και 3-1",
    "WINNING_MARGIN": "Περιθώριο νίκης",
    "Over 2.5": "Over 2.5",
    "0-1,0-2,1-2": "0-1,0-2,1-2",
    "LOST": "Χαμένο",
    "EACH_WAY": "Each-Way",
    "SCHEDULED_EVENT": " ",
    "Greece": "Ελλάδα",
    "Away": "{1}",
    "GAME_DISABLED": "Μη διαθεσιμο γεγονός",
    "Field Goal": "Field Γκολ",
    "Boston": "Boston",
    "Cars": "Αυτοκίνητα",
    "Munich": "Munich",
    "Horses Jumps": "Ιπποδρομίες μετ΄εμποδίων",
    "Ukraine": "Ukraine",
    "PLACE_YOUR_BETS": "Τοποθετήστε τα στοιχήματά σας",
    "Piraeus": "Piraeus",
    "EACH_WAY_ODDS_SHOW": "E/W {0} 1-2-3",
    "Athens": "Athens",
    "245-249": "245-249",
    "46-50": "46-50",
    "AWAY_TEAM_GOALS": "Γκολ ομάδας {1}",
    "Turkey": "Turkey",
    "Belgium": "Belgium",
    "New England": "New England",
    "CLOSE_BET_SLIP": "Κλείνω",
    "BET_SELECTION_MESSAGE": "Κάντε την επιλογή σας παρακάτω.",
    "SETTLED_BETS": "Κλειστά",
    "Away and 2-2": "{1} και 2-2",
    "-10.5": "-10.5",
    "Over 3.5": "Over 3.5",
    "Away and 2-1": "{1} και 2-1",
    "DATE_FORMAT": "DD/MM/YYYY HH:mm",
    "MARKETS": "Αγορές",
    "Turnover on or after 5th Play": "Λάθος στο/ή και μετά το 5ο Play",
    "Rolling Downs": "Rolling Downs",
    "COMBINATION_TRICAST": "Combo Τρικάστ",
    "BROWSER_NOT_SUPPORTED": "Μη υποστηριζόμενο πρόγραμμα περιήγησης",
    "Both Score No": "Οχι",
    "Under 209.5": "Under 209.5",
    "Amsterdam": "Amsterdam",
    "145-149": "145-149",
    "SPREAD": "Χάντικαπ",
    "3-0,3-1,4-0": "3-0,3-1,4-0",
    "51 And Over": "Πάνω από 50",
    "51 And Over Short": "Π 50",
    "Croatia": "Croatia",
    "HELP": "Βοήθεια",
    "1-1,2-2": "1-1,2-2",
    "Rush Dogs": "Κυνοδρομίες",
    "Formula Racing": "Μηχανοκίνητα",
    "Uruguay": "Uruguay",
    "No Goal": "Χωρίς Γκολ",
    "225-229": "225-229",
    "HorsesJumps": "PS Downs",
    "Virtual Arena": "OPAP Arena",
    "FORECAST_MARBLE": "Πρώτα 2",
    "Rumble Turns": "",
    "Away Win By Exactly 2 Goals": "{1} Νίκη με ακριβώς 2 Γκολ",
    "MB_FOOTBALL_ON": "on",
    "MORE": "Περισσότερα",
    "Home Not to Score": "{0} Να μη σκοράρει",
    "RACERS": "Δρομείς",
    "Over 164.5": "Over 164.5",
    "EXPAND_ALL": "Διεύρυνση Αγορών",
    "HorsesSprints": "PS Sprints",
    "125-129": "125-129",
    "Home Not To Score": "{0} Να μη σκοράρει",
    "Over 0.5": "Over 0.5",
    "130-134": "130-134",
    "Any Other": "Όλα τα άλλα",
    "Away and 1-3": "{1} και 1-3",
    "Euro Arena": "Ευρώ Arena",
    "Away and 1-1": "{1} και 1-1",
    "Away and 1-2": "{1} και 1-2",
    "Score draw": "Ισοπαλία",
    "FORECAST": "Φορκάστ",
    "NO_BETS": "Κανένα στοίχημα",
    "CLEAR_LAST": "Διαγραφή τελευταίου",
    "ADVERTISING_SPACE": "ADVERTISING SPACE",
    "Under 180": "Under 180",
    "REMOVED": "αφαιρέθηκε",
    "CORRECT_SCORE": "Ακριβές σκορ",
    "Victoria Park": "Markopoulo Park",
    "Away Win By Exactly 1 Goal": "{1} Νίκη με ακριβώς 1 Γκολ",
    "GOALS": "Γκολ",
    "FIRST_ST": "1",
    "Green Bay": "Green Bay",
    "Under 219.5": "Under 219.5",
    "Draw/Home": "Ισοπαλία/{0}",
    "25 And Under": "Κάτω από 26",
    "25 And Under Short": "Κ 26",
    "Tel Aviv Yellows": "Tel Aviv Yellows",
    "WIN": "Γκανιάν",
    "EN_GB": "Αγγλικά (Μεγάλη Βρετανία)",
    "LOADING": "Φόρτωση",
    "Away and 0-4": "{1} και 0-4",
    "Away and 0-2": "{1} και 0-2",
    "CLOSED": "Κλειστά",
    "Away and 0-3": "{1} και 0-3",
    "Egypt": "Αίγυπτος",
    "Over 1.5": "Over 1.5",
    "Away and 0-1": "{1} και 0-1",
    "Dogs2": "Markopoulo Green",
    "Cleveland": "Cleveland",
    "Turnover on 1st Play": "Λάθος στο 1ο Play",
    "RunTD on 3rd Play": "TD με run στο 3ο Play",
    "Over 154.5": "Over 154.5",
    "AUTHENTICATION_REQUIRED": "Παρακαλώ συνδεθείτε για να συνεχίσετε",
    "HALF_TIME_CORRECT_SCORE": "1ο ημίχρονο - Ακριβές σκορ",
    "Holland": "Holland",
    "STAKE": "Στοίχημα",
    "+15.5": "+15.5",
    "Chicago": "Chicago",
    "230-234": "230-234",
    "FOURTH_PLAY": "4ο Play",
    "AMERICAN": "Αμερικάνικες",
    "Turnover on 3rd Play": "Λάθος στο 3ο Play",
    "FORECAST_TRICAST": "Φορκάστ/Τρικάστ",
    "THIRD_RD": "3",
    "EXACTA": "Φορκάστ",
    "Denmark": "Denmark",
    "EXACTA_BOX": "Combo Φορκάστ",
    "slash": "/",
    "RESULT": "Αποτέλεσμα",
    "Valencia": "Valencia",
    "SELECT_YOUR_BET_BELOW": "Επιλέξτε Το Στοίχημά Σας",
    "US": "US",
    "BET_BOTH": "Και στα δύο",
    "HANDICAP": "1Χ2 Χάντικαπ",
    "HANDICAP_FIRST": "1Χ2 Χάντικαπ Γηπεδούχος +1",
    "HANDICAP_SECOND": "1Χ2 Χάντικαπ Φιλοξενούμενη +1",
    "EW": "E/W",
    "0-5": "0-5",
    "0-6": "0-6",
    "5-0": "5-0",
    "6-0": "6-0",
    "3-3": "3-3",
    "3-2": "3-2",
    "2-3": "2-3",
    "4-1": "4-1",
    "1-4": "1-4",
    "4-2": "4-2",
    "2-4": "2-4",
    "5-1": "5-1",
    "1-5": "1-5",
    "Auto Raceway": "PS Raceway",
    "RACE_CARD": "Κάρτα Κούρσας",
    "SELECTION_REMOVAL": "Αυτή η επιλογή θα αφαιρεθεί στις ",
    "SECONDS": " Δευτερόλεπτα",
    "SECOND": " Δευτερόλεπτο",
    "BET_NON_DIVISIBLE_MESSAGE": "Ένα ή περισσότερα στοιχήματα  δεν διαιρούνται από το {0}. Διορθώστε το πριν τοποθετήσετε τα στοιχήματά σας.",
    "SINGLE_BET_COMMIT_MESSAGE": "Δεν μπορείτε να τοποθετήσετε πολλαπλά μονά στοιχήματα",
    "EVENT_LIVE_MSG_LINE_1": "Παίζει τώρα",
    "EVENT_LIVE_MSG_LINE_2": "Επιλέξτε από τους επερχόμενους ",
    "EVENT_LIVE_MSG_LINE_3": "αγώνες παραπάνω",
    "LOOK_FOR_THE": "Αναζητήστε",
    "NEXT_SCHEDULED": "Eπόμενο Προγραμματισμένο",
    "EVENT": "γεγονός",
    "NEXT": "Επόμενη",
    "FUTURE": "Μελλοντικό",
    "PLAYING": "Playing",
    "PLACE_MARBLE": "Πλασέ",
    "SHOW_MARBLE": "Εμφάνιση",
    "betSlip_Matchday_English": "Αγγλική Αγωνιστική",
    "betSlip_Matchday_Turkish": "Turkish Αγωνιστική",
    "betSlip_Matchday_Greek": "Ελληνική Αγωνιστική",
    "betSlip_Soccer": "Ποδόσφαιρο",
    "betSlip_Horses": "Αλογα",
    "betSlip_Basketball": "Μπάσκετ",
    "betSlip_Dogs": "Κυνοδρομίες",
    "betSlip_Motor Racing": "Αγώνες μηχανών",
    "betSlip_US Football": "Αμερ. Ποδόσφαιρο",
    "betSlip_Marble Racing": "Αγώνες με μπίλιες",
    "POS": "θέση",
    "TEAM": "ομ",
    "P": "Ολ",
    "W": "Ν",
    "D": "Ι",
    "L": "Η",
    "F": "Υ",
    "A": "Κ",
    "PTS": "β.",
    "LEAGUE TABLE": "Κατάταξη",
    "TREND": "Τάση",
    "Matchday_Islington": "ISL",
    "Matchday_City": "CTY",
    "Matchday_Palace": "PAL",
    "Matchday_Chelsea": "CHE",
    "Matchday_Southampton": "SOU",
    "Matchday_Wolverhampton": "WOL",
    "Matchday_Sheffield": "SHE",
    "Matchday_Leicester": "LEI",
    "Matchday_Newcastle": "NEW",
    "Matchday_Tottenham": "TOT",
    "Matchday_West Ham": "WHA",
    "Matchday_United": "UTD",
    "Matchday_Leeds": "LEE",
    "Matchday_Liverpool": "LIV",
    "Matchday_Everton": "EVE",
    "Matchday_Aston": "AST",
    "Matchday_Basaksehir": "BAS",
    "Matchday_Trabzon": "TRZ",
    "Matchday_Besiktas": "BKS",
    "Matchday_Sivas": "SIV",
    "Matchday_Alanya": "ALA",
    "Matchday_Galata": "GLS",
    "Matchday_Fenerbahce": "FRB",
    "Matchday_Gazientep": "GAZ",
    "Matchday_Antalya": "ANT",
    "Matchday_Kasimpasa": "KAS",
    "Matchday_Goztepe": "GOZ",
    "Matchday_Gencler": "ESK",
    "Matchday_Konya": "BUR",
    "Matchday_Rize": "RIZ",
    "Matchday_Malatya": "MAL",
    "Matchday_Kayseri": "KAY",

    //Matchday Greek Teams
    "Matchday_Dikefalos Vora": "ΔΙΚ",
    "Matchday_Erithrolefkoi": "ΘΡΥ",
    "Matchday_Enosi": "ΕΝΩ",
    "Matchday_Peristeri": "ΠΕΡ",
    "Matchday_Prasinoi": "ΠΡΑ",
    "Matchday_Kitrinoi Vora": "ΚΙΤ",
    "Matchday_Nea Smirni": "ΣΜΥ",
    "Matchday_Xanthi": "ΞΑΝ",
    "Matchday_Tripoli": "ΤΡΙ",
    "Matchday_Agrinio": "ΑΓΡ",
    "Matchday_Larisa": "ΛΑΡ",
    "Matchday_Lamia": "ΛΑΜ",
    "Matchday_Ioannina": "ΙΩΑ",
    "Matchday_Iraklio": "ΗΡΑ",
    "Matchday_A.O. Rizoupolis": "ΡΙΖ",
    "Matchday_Volos": "ΒΟΛ",

    //Soccer3 Greek Teams
    "Dikefalos Vora": "ΔΙΚ",
    "Erithrolefkoi": "ΘΡΥ",
    "Enosi": "ΕΝΩ",
    "Peristeri": "ΠΕΡ",
    "Prasinoi": "ΠΡΑ",
    "Kitrinoi Vora": "ΚΙΤ",
    "Nea Smirni": "ΣΜΥ",
    "Xanthi": "ΞΑΝ",
    "Tripoli": "ΤΡΙ",
    "Agrinio": "ΑΓΡ",
    "Larisa": "ΛΑΡ",
    "Lamia": "ΛΑΜ",
    "Ioannina": "ΙΩΑ",
    "Iraklio": "ΗΡΑ",
    "A.O. Rizoupolis": "ΡΙΖ",
    "Volos": "ΒΟΛ",

    "Dortmund": "Dortmund",
    "Chelsea": "Chelsea",
    "Porto": "Porto",
    "Rome": "Rome",
    "Benfica": "Benfica",
    "Celtic": "Celtic",
    "United": "United",
    "UNDER_OVER_MATCHDAY": "Over/Under",
    "UNDER_OVER_05_SHORT": "0.5",
    "UNDER_OVER_15_SHORT": "1.5",
    "UNDER_OVER_25_SHORT": "2.5",
    "UNDER_OVER_35_SHORT": "3.5",
    "UNDER_SHORT": "U",
    "OVER_SHORT": "Ο",
    "FULL TIME": "FULL TIME",
    "FT": "FT",
    "System": "Σύστημα",
    "x1": "(x1)",
    "Multiplier": "Repeat Bet",
    "Main markets": "Κύριες Αγορές",
    "4RANDOM": "4 Τυχαία",
    "6RANDOM": "6 Τυχαία",
    "8RANDOM": "8 Τυχαία",
    "8FAVS": "8 Φαβορί",
    "QUICK_SELECT": "Γρήγορη Επιλογή",
    "UNDER_OVER_2_5": "Over/Under 2.5",
    "UNDER_OVER_3_5": "Over/Under 3.5",
    "MATCH_RESULT": "Τελικό αποτέλεσμα",
    "YES": "Ναι",
    "NO": "Οχι",
    "REALITY_CHECK_WARNING_YES": "Ναι",
    "REALITY_CHECK_WARNING_NO": "Οχι",
    "ACCUMULATOR": "Παρολί",
    "+1G": "+1G",
    "Single": "Μονό",
    "Doubles": "δυάδα(ες)",
    "Trebles": "τριάδα(ες)",
    "Four Folds": "4 άδα(ες)",
    "Five Folds": "5 άδα(ες)",
    "Six Folds": "6 άδα(ες)",
    "Seven Folds": "7 άδα(ες)",
    "Eight Folds": "8 άδα(ες)",
    "MD": "Aγ.{0}",
    "MATCH": "Αποτέλεσμα",
    "INVALID_ACCA": "Όπου οι επιλογές επισημαίνονται, οι πολλαπλές επιλογές σας είναι περιορισμένες",
    "INVALID_ODDS": "Η αποδόση είναι πολύ υψηλή. Παρακαλώ αλλάξτε τις επιλογές σας",
    "INVALID_ACCA_MORETHAN_8": "Τα παρολί στοιχήματα δεν μπορούν να περιέχουν περισσότερες από 8 επιλογές μέσα σε έναν αγώνα",
    "Any": "κάθε",
    "UNDER": "UNDER",
    "OVER": "OVER",
    // Accumulator Boost
    "ACCUMULATOR_BOOST": 'Bonus Παρολί',
    "ACCUMULATOR_INFO": 'Εάν το παρολί στοίχημά σας κερδίσει, ένα μπόνους {0}% - {1}% θα προστεθεί στις επιστροφές σας. Το ποσό μπόνους εξαρτάται από τον αριθμό των επιλογών.',
    "BET_TYPE": 'Τύπος στοιχήματος',
    "BOOST": 'Bonus',
    "Bonus_Info": " {0}% Bonus",
    "+": "+",
    "Bonus_Value": "Συμπερ. {0} Bonus",
    "BOOST_PERCENTAGE": "{0}%",
    "BOOST_BONUS_START": "παρολί {0} ή περισσοτέρων επιλογών θα λάβει Bonus",
    "BOOST_BONUS_UPGRADE": "προσθέστε ένα άλλο παρολί για να λάβετε ένα επιπλέον Bonus",
    "BOOST_BONUS_MAX": "έχετε το μέγιστο Bonus παρολί",
    "Marbles_Euro_1": "Belgium",
    "Marbles_Euro_2": "Croatia",
    "Marbles_Euro_3": "Denmark",
    "Marbles_Euro_4": "England",
    "Marbles_Euro_5": "France",
    "Marbles_Euro_6": "Germany",
    "Marbles_Euro_7": "Italy",
    "Marbles_Euro_8": "Netherlands",
    "Marbles_Euro_9": "Portugal",
    "Marbles_Euro_10": "Spain",
    "Short_Over": "Over {0}",
    "Short_Under": "Under {0}",

    //Game Tabs
    'Football': 'Αμερ. Ποδόσφαιρο',
    'Matchday': 'Αγωνιστική',
    'Basketball': 'Μπάσκετ',
    'Dogs': 'Κυνοδρομίες',
    'Motor Racing': 'Μηχανοκίνητα',
    'Results': 'Αποτελέσματα',
    'Horses': 'Αλογα',
    'Soccer': 'Ποδόσφαιρο',
    'US Football': 'Αμερ. Ποδόσφαιρο',
    'Marble Racing': 'μπίλια',
    "Matchday_English": "Αγωνιστική",
    "Matchday_Turkish": "Αγωνιστική",
    "Matchday_Greek": "Αγωνιστική",

    //Game SubTabs
    'Soccer_Euro': 'Ευρώ',
    "Soccer_Soccer3_Super_League": "Σούπερ Λίγκ",
    "Soccer_Soccer3_Greek_League": "Ελληνική Λίγκ",
    'Soccer_Super_League': 'Σούπερ Λίγκ',
    'Soccer_World_Cup': 'Παγκόσμιο Κύπελλο',
    'Soccer_Soccer3_World_Cup': 'Παγκόσμιο Κύπελλο',
    'Horses_Sprints': 'Σπριντ',
    'Horses_Flats': 'Επίπεδο',
    'Horses_Jumps': 'Με εμπόδια',
    'Basketball_US1': 'ΗΠΑ1',
    'Basketball_US2': 'ΗΠ2',
    'Basketball_Europe': 'Ευρώπη',
    'Dogs_Flats': 'Επίπεδο',
    'Dogs_City': 'Στατικός',
    'Motor_Racing_Stock_Cars': 'Αγώνες Stock Car',
    'Motor_Racing_Indy_Cars': 'Αγώνες Indy Car',
    'US_Football_NFLA': 'NFLA',
    'US_Football_NFL': 'NFL',
    'US_Football_Football': 'Αμερ. Ποδόσφαιρο',
    'Marble_Racing_Marbles': 'Μπίλιες',
    'Marble_Racing_Marbles2': 'Χώμα',
    'Marble_Racing_Marbles_Euro': 'Ευρώ Μπίλιες',
    'Marble_Racing_Marbles_Halloween': 'Halloween',
    "Matchday_English_Matchday_English": "Αγωνιστική",
    "Matchday_Turkish_Matchday_Turkish": "Αγωνιστική",
    "Matchday_Greek_Matchday_Greek": "Αγωνιστική",
    "DEMOPLAY_NOTIFICATION_MESSAGE_LINE_1": "Please register or log in to place a bet",
    "DEMOPLAY_NOTIFICATION_MESSAGE_LINE_2": " ",
    "DEMOPLAY_NOTIFICATION_DISMISS": "Dismiss",
    "DEMOPLAY_NOTIFICATION_OK": "OK",
    "Matchday_Moroccan": "Journée",
    "Matchday_Moroccan_Matchday_Moroccan": "Journée",
    "betSlip_Matchday_Moroccan": "Journée",

    //Matchday Moroccan Teams
    "Matchday_Casa Reds": "WYD",
    "Matchday_Casa Greens": "RAJ",
    "Matchday_Fès": "FES",
    "Matchday_El Jadida": "ELJ",
    "Matchday_Berkane": "BKN",
    "Matchday_Feth": "FTH",
    "Matchday_FARabat": "FAR",
    "Matchday_Mohammedia": "MOH",
    "Matchday_Soualem": "SLM",
    "Matchday_Khouribga": "KHO",
    "Matchday_Tanger": "TAN",
    "Matchday_Agadir": "AGA",
    "Matchday_Berrechid": "BER",
    "Matchday_Oujda": "OUJ",
    "Matchday_Safi": "SAF",
    "Matchday_Oued Zem": "ODZ",
    "Matchday_Tétouan": "TET",
    "Matchday_Touarga": "TRG",
    "Matchday_Beni Mellal": "BNM",
    "Matchday_Stade Maroc": "STM",
    "Matchday_Zemamra": "ZMR",

    "Soccer_Soccer3_Moroccan_League": "Moroccan",
    //Soccer3 Moroccan Teams
    "Casa Reds": "Casa Reds",
    "Casa Greens": "Casa Greens",
    "Fès": "Fès",
    "El Jadida": "El Jadida",
    "Berkane": "Berkane",
    "Feth": "Feth",
    "FARabat": "FARabat",
    "Mohammedia": "Mohammedia",
    "Soualem": "Soualem",
    "Khouribga": "Khouribga",
    "Tanger": "Tanger",
    "Agadir": "Agadir",
    "Berrechid": "Berrechid",
    "Oujda": "Oujda",
    "Safi": "Safi",
    "Oued Zem": "Oued Zem",
    "Tétouan": "Tétouan",
    "Touarga": "Touarga",
    "Beni Mellal": "Beni Mellal",
    "Stade Maroc": "Stade Maroc",
    "Zemamra": "Zemamra",
    "QUICK_FILL": "Quick Fill",
    "MAD" : "{0} MAD",

    //Matchday Belgium
    "Matchday_Belgium": "Αγωνιστική",
    "Matchday_Belgium_Matchday_Belgium": "Αγωνιστική",
    "betSlip_Matchday_Belgium": "Βέλγιο Αγωνιστική",
    //Matchday Belgium Teams
    "Matchday_Saint-Gilles": "SAI",
    "Matchday_Club": "CLU",
    "Matchday_Anderlecht": "AND",
    "Matchday_Antwerp": "ANT",
    "Matchday_Gent": "GEN",
    "Matchday_Mechelen": "MEC",
    "Matchday_Charleroi": "CHA",
    "Matchday_Genk": "GNK",
    "Matchday_Brugge": "BRU",
    "Matchday_Sint-Truiden": "SIN",
    "Matchday_Leuven": "LEU",
    "Matchday_Kortrijk": "KOR",
    "Matchday_Liege": "LIE",
    "Matchday_Oostende": "OOS",
    "Matchday_Waregem": "WAR",
    "Matchday_Eupen": "EUP",
    "Matchday_Seraing": "SER",

    //BonusBet
    "Gift_for_You_Heading" :"A GIFT FOR YOU",
    "Gift_for_You_Content": "Congratulations! You have promotional offers to redeem.",
    "View_Offers" : "VIEW OFFERS",
    "Do_Not_Show_MSG": "DO NOT SHOW AGAIN",
    "MY_OFFERS" : 'MY OFFERS',
    "SELECT_OFFER" : 'SELECT YOUR OFFER',
    "NO_OFFER" : 'THERE ARE NO ACTIVE OFFERS',
    "CHOOSE_BET": 'CHOOSE BET',
    "Opt_In": 'OPT IN',
    "Key_Terms_Heading" :"KEY TERMS",
    "No_Thanks" : "NO THANKS",
    "PROMO_BET": 'PROMO BET',
    "Time_To_Bet": "TIME TO BET",
    "OPTED_IN_MSG": "THANKS, YOU HAVE OPTED IN",
    "EXP": "Exp.",
    "SELECT": "Select",
    "DEMO_SITE_PROMO_NOT_AVAILABLE": "This demo site does not currently offer any promos. Please log in/register to access current offers. !",
    "Horses_US_Horses": "USA",

    //Cricket
    "Cricket" : "Κρίκετ",
    "Cricket_International": "Διεθνής ",
    "betSlip_Cricket": "Κρίκετ",
    //circket teams
     "Australia":"Australia",
     "India":"India",
     "Pakistan":"Pakistan",
     "West Indies" : "West Indies",
     "Sri Lanka":"Sri Lanka",
     "New Zealand":"New Zealand",
     "South Africa":"South Africa",
     "Australia_short":"AUS",
     "WestIndies_short" : "WI",
     "SriLanka_short":"SRI",
     "NewZealand_short":"NZL",
     "India_short":"IND",
     "SouthAfrica_short":"RSA",
     "Pakistan_short":"PAK",
     "England_short": "ENG",
     "Tie":"Tie",
    //cricket markets
     "MATCH_WINNER":"Νικητής αγώνα",
     "TOTAL_SIXES_IN_MATCH":"Συνολικά 6άρια αγώνα",
     "TOTAL_SIXES_IN_MATCH_SHORT": "Under 1.5",
     "TOTAL_FOUR_IN_MATCH":"Συνολικά 4άρια αγώνα",
     "TOTAL_BOUNDARIES_IN_MATCH":"Συνολικά boundary αγώνα",
     "FIRST_TEAM_TOTAL_RUNS":"{0} Συνολικά run",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL":"{0} Run από την πρώτη μπαλιά",
     "FIRST_TEAM_WICKET_LOST":"{0} Wicket Lost",
     "FIRST_TEAM_WICKET_LOST_DISMISSAL_TYPE": "{0} Πρώτος τύπος αποβολής",
     "FIRST_TEAM_RUN_OFF_FIRST_BALL_OVER_UNDER_05_SHORT": "0.5",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_15_SHORT": "1.5",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_25_SHORT": "2.5",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_35_SHORT": "3.5",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_UNDER_OVER":"{0} Run από την πρώτη μπαλιά πάνω/κάτω από",
     "FIRST_TEAM_RUN_OFF_FIRST_BALL_OVER_UNDER_05": "{0} Run από την πρώτη μπαλιά πάνω/κάτω από",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_15": "{0} Run από την πρώτη μπαλιά πάνω/κάτω από",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_25": "{0} Run από την πρώτη μπαλιά πάνω/κάτω από",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_35": "{0} Run από την πρώτη μπαλιά πάνω/κάτω από",
     "Caught" : "Caught",
     "Bowled":"Bowled",
     "LBW":"LBW",
     "No Wicket":"No Wicket",
     "OverZeroPointFive": "Over 0.5",
     "UnderZeroPointFive": "Under 0.5",
     "OverOnePointFive": "Over 1.5",
     "UnderOnePointFive": "Under 1.5",
     "OverTwoPointFive": "Over 2.5",
     "UnderTwoPointFive": "Under 2.5",
     "OverThreePointFive": "Over 3.5",
     "UnderThreePointFive": "Under 3.5",
     "Yes": "Yes",
     "No":"No",
     "FINAL_SCORE":"Final Score",
     OVER_145: 'Over 14.5',
     UNDER_145: 'Under 14.5',
     DRAW_Cricket: "DRAW",
      //TENNIS
    TOTAL_POINTS:"Συνολικοί πόντοι",
    HANDICAP_TENNIS: "Χάντικαπ",
    Scotland :"Scotland",
    USA: "USA",
    Tennis_International: "Διεθνές",
    betSlip_Tennis: "Τένις",
    "Win By 2 or 3": "Νίκη με 3 πόντουςή λιγότερους",
	"Win By 4 or 5": "Νίκη με 4ή 5 πόντους",
	"Win By 6 or 7": "Νίκη με 6ή 7 πόντους",
    "Tennis": "Τένις",
   //baseball
    WINNER : "ΝΙΚΗΤΗΣ",
    TOTAL_HOME_RUNS_UNDER_OVER: "ΣΥΝΟΛΟ HOME RUN O/U",
    TOTAL_HOME_RUNS:  "ΑΚΡΙΒΕΣ ΣΥΝΟΛΟ HOME RUN",
    WINNER_AND_TOTAL_HOME_RUNS_OVER_UNDER:"ΝΙΚΗΤΗΣ ΚΑΙ ΣΥΝΟΛΟ HOME RUN O/U 5.5",
    WINNER_AND_TOTAL_HOME_RUNS_OVER_UNDER_SHORT:"Νικητής και Σύνολο Home Run O/U 5.5",
    BATTER1_HOME_RUNS: "HOME RUN {0}",
    BATTER2_HOME_RUNS: "HOME RUN {1}",
    Baseball_HR_ShootOut_Legends: "Home Run Shootout-Legends",
    Baseball_HR_ShootOut_Legends_SHORT: "HR Shootout",
    "Baseball": "Μπέιζμπολ",
    "betSlip_Baseball": "Μπέιζμπολ",
    "Player 1 AND OVER_5_5":"{0} και Over 5.5",
    "Player 2 AND OVER_5_5":"{0} και Over 5.5",
    "Player 1 AND UNDER_5_5":"{0} και Under 5.5",
    "Player 2 AND UNDER_5_5":"{0} και Under 5.5",
    "Draw AND OVER_5_5":"Ισοπαλία και Over 5.5",
    "Draw AND UNDER_5_5":"Ισοπαλία και Under 5.5",
    "HOME RUNS":"{0} Home Runs",
    "Next Fixtures":"Next Fixtures",
    "MATCH_IN_PROGRESS": "Match In Progress",
    "Matchday_Light_English": "Matchday Light",
    "Matchday_Light_English_Matchday_Light_English": "English League",
    "betSlip_Matchday_Light_English": "Matchday Light",

    //NFL
    'Cardinals' : 'Cardinals',
    'Falcons' : 'Falcons',
    'Ravens' : 'Ravens',
    'Bills' : 'Bills',
    'Panthers' : 'Panthers',
    'Bears' : 'Bears',
    'Bengals' : 'Bengals',
    'Browns' : 'Browns',
    'Cowboys' : 'Cowboys',
    'Broncos' : 'Broncos',
    'Lions' : 'Lions',
    'Packers' : 'Packers',
    'Texans' : 'Texans',
    'Colts' : 'Colts',
    'Jaguars' : 'Jaguars',
    'Chiefs' : 'Chiefs',
    'Raiders' : 'Raiders',
    'Chargers' : 'Chargers',
    'Rams' : 'Rams',
    'Dolphins' : 'Dolphins',
    'Vikings' : 'Vikings',
    'Patriots' : 'Patriots',
    'Saints' : 'Saints',
    'Giants' : 'Giants',
    'Jets' : 'Jets',
    'Eagles' : 'Eagles',
    'Steelers' : 'Steelers',
    '49ers' : '49ers',
    'Seahawks' : 'Seahawks',
    'Buccaneers' : 'Buccaneers',
    'Titans' : 'Titans',
    'Commanders' : 'Commanders',
    'NEW' : 'New',
    //Soccer_Soccer3_Turkish_League team names and game name
    "Soccer_Soccer3_Turkish_League": "Turkish League",
    "Basaksehir": "BAS",
    "Trabzon": "TRZ",
    "Besiktas": "BKS",
    "Sivas": "SIV",
    "Alanya": "ALA",
    "Galata": "GLS",
    "Fenerbahce": "FRB",
    "Gazientep": "GAZ",
    "Antalya": "ANT",
    "Kasimpasa": "KAS",
    "Goztepe": "GOZ",
    "Gencler": "ESK",
    "Konya": "BUR",
    "Rize": "RIZ",
    "Malatya": "MAL",
    "Kayseri": "KAY",

    //NBA 
  "Basketball_NBA": "NBA",
  "Atlanta Hawks": "Atlanta Hawks",
  "Boston Celtics": "Boston Celtics",
  "Brooklyn Nets": "Brooklyn Nets",
  "Charlotte Hornets": "Charlotte Hornets",
  "Chicago Bulls": "Chicago Bulls",
  "Cleveland Cavaliers": "Cleveland Cavaliers",
  "Dallas Mavericks": "Dallas Mavericks",
  "Denver Nuggets": "Denver Nuggets",
  "Detroit Pistons": "Detroit Pistons",
  "Golden State Warriors": "Golden State Warriors",
  "Houston Rockets": "Houston Rockets",
  "Indiana Pacers": "Indiana Pacers",
  "Los Angeles Clippers": "Los Angeles Clippers",
  "Los Angeles Lakers": "Los Angeles Lakers",
  "Memphis Grizzlies": "Memphis Grizzlies",
  "Miami Heat": "Miami Heat",
  "Milwaukee Bucks": "Milwaukee Bucks",
  "Minnesota Timberwolves": "Minnesota Timberwolves",
  "New Orleans Pelicans": "New Orleans Pelicans",
  "New York Knicks": "New York Knicks",
  "Oklahoma City Thunder": "Oklahoma City Thunder",
  "Orlando Magic": "Orlando Magic",
  "Philadelphia 76ers": "Philadelphia 76ers",
  "Phoenix Suns": "Phoenix Suns",
  "Portland Trail Blazers": "Portland Trail Blazers",
  "Sacramento Kings": "Sacramento Kings",
  "San Antonio Spurs": "San Antonio Spurs",
  "Toronto Raptors": "Toronto Raptors",
  "Utah Jazz": "Utah Jazz",
  "Washington Wizards": "Washington Wizards",
  "TOTALPOINTS": "TOTAL POINTS"

};


// WEBPACK FOOTER //
// ./src/localization/el_GR.js